import isComingSoon from "./isComingSoon";

const getBadgeText = ({ formatTranslation, earlyAccess }) =>
  isComingSoon({ earlyAccess })
    ? formatTranslation("coming_soon_label")
    : formatTranslation("early_access_label");

export default getBadgeText;
